module.exports = __webpack_public_path__ + "img/bxs_edit.72d79a8b.svg";